<template>
    <div class="course-container">
        <!--详情-->
        <div class="lesson-container" v-show="this.showMode==='view'">
            <!--信息-->
            <div class="left-container">
                <div class="top-title">师资培训详情</div>
                <div class="info-column-container">
                    <div class="flex-item column-title">基本信息</div>
                    <div class="flex-item column-status" v-if="lessonInfo.status===0">初始</div>
                    <div class="flex-item column-status" v-if="lessonInfo.status===1">进行中</div>
                    <div class="flex-item column-status-fb" v-if="lessonInfo.status===2">已结束</div>
                    <div class="flex-item column-btn">
                        <div class="btn"
                             v-if="lessonInfo.status!==2&&(this.role==='1'||this.role==='2'||this.userId===lessonInfo.createUser)"
                             @click="editLesson">
                            编辑
                        </div>
                        <div class="btn"
                             v-if="lessonInfo.status!==2&&(this.role==='1'||this.role==='2'||this.userId===lessonInfo.createUser)"
                             @click="stopLesson">
                            结束培训
                        </div>
                        <div class="btn"
                             v-if="lessonInfo.roleType && (lessonInfo.roleType.includes('1') || lessonInfo.roleType.includes('2') || lessonInfo.roleType.includes('4')) "
                             @click="handleHomework">
                            作业管理
                        </div>
                        <div class="btn"
                             v-if="lessonInfo.roleType && lessonInfo.roleType.includes('3')"
                             @click="handleHomeworkFinish">
                            作业提交
                        </div>
                    </div>
                </div>
                <div class="base-info-container">
                    <div class="part-container">
                        <div class="part1-l">
                            <div class="info-lesson-title">
                                [师资培训]{{lessonInfo.title}}
                            </div>
                            <div class="info-item">
                                <div>培训类型：{{lessonInfo.classifyName}}</div>
                                <div>培训形式：<span v-if="lessonInfo.type === 0">直播直播</span><span v-if="lessonInfo.type === 1">录播培训</span><span v-if="lessonInfo.type === 2">现场培训</span><span v-if="lessonInfo.type === 3">录播培训</span></div>
                            </div>
                            <div class="info-item">
                                <div>培训性质：<span v-if="lessonInfo.trainNature === '1'">普通</span><span v-if="lessonInfo.trainNature === '2'">名师工作室</span><span v-if="lessonInfo.trainNature === '3'">名校长工作室</span><span v-if="lessonInfo.trainNature === '4'">群组培训</span></div>
                                <div v-if="lessonInfo.type === 2">
                                    签到次数：{{lessonInfo.signTotalCount}}
                                </div>
                            </div>
                            <div class="info-item">
                                任务时段：{{ timestampToTime(lessonInfo.beginTime)}}至{{ timestampToTime(lessonInfo.endTime)}}
                            </div>
                            <div class="info-item" v-if="lessonInfo.type === 2&&lessonInfo.signInBeginTime&&lessonInfo.signOutBeginTime">
                                <div>签到时间：{{timestampToDate(lessonInfo.signInBeginTime) }}至{{ timestampToDate(lessonInfo.signInEndTime) }}</div>
                                <div>签退时间：{{timestampToDate(lessonInfo.signOutBeginTime) }}至{{ timestampToDate(lessonInfo.signOutEndTime)}}</div>
                            </div>
                            <div class="info-item" v-if="lessonInfo.leadTeacherNames||lessonInfo.leadTeacherNames">
                                <div v-if="lessonInfo.leadTeacherNames">班主任：{{lessonInfo.leadTeacherNames}}</div>
                                <div v-if="lessonInfo.viceLeadTeacherNames">副班主任：{{lessonInfo.viceLeadTeacherNames}}</div>
                            </div>
                            <div class="info-item-auto">
                                <div class="title-label">参与人员：</div>
                                <div class="content-label"><expendText :text="lessonInfo.joinUsersText"></expendText></div>
                            </div>
                            <div class="info-item-auto">
                                <div class="title-label">培训内容：</div>
                                <div class="content-label"><expendText :text="lessonInfo.content"></expendText></div>
                            </div>
                            <div class="info-item-auto" v-if="lessonInfo.type === 2">
                                培训地址：{{lessonInfo.signInAddress}}
                            </div>
                            <div class="map-container" v-if="lessonInfo.type === 2">
                                <aMap isDetail v-if="isShowMap" ref="zdyMap"
                                      @getGeocoder="getGeocoder"
                                      :oldCenter="oldCenter"
                                      :isShowAMap="true">
                                </aMap>
                            </div>
                        </div>
                        <div class="part1-r">
                            <div class="base-info-cover">
                                <img class="img-100"  :src="lessonInfo.coverUrl" alt="">
                            </div>
                            <div class="base-info-cover">
                                <div class="code-item"  v-if="lessonInfo.status!==2">
                                    <div class="code-title">
                                        参训邀请码
                                    </div>
                                    <div class="code-img" @click="handleTkDownload">
                                        <el-tooltip
                                          class="box-item"
                                          effect="dark"
                                          content="点击下载二维码"
                                          placement="bottom">
                                            <vueQr ref="tkcode" :text="qrCode.shareUrl"
                                                   :size="qrCode.size"
                                                   :margin="qrCode.margin"/>
                                        </el-tooltip>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <!--满意度量表 -->
                <div class="info-column-container" v-if="scaleList1&&scaleList1.length>0">
                    <div class="column-title">满意度调查</div>
                </div>
                <div class="file-list">
                    <div class="file-item" v-for="item in scaleList1" :key="item">
                        <div class="file-title" @click="handleComplete(item)">{{item.title}}</div>
                        <div class="file-view" @click="handleComplete(item)">
                            <svg t="1742436699597" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2755" width="22" height="22"><path d="M938.666667 553.92V768c0 64.8-52.533333 117.333333-117.333334 117.333333H202.666667c-64.8 0-117.333333-52.533333-117.333334-117.333333V256c0-64.8 52.533333-117.333333 117.333334-117.333333h618.666666c64.8 0 117.333333 52.533333 117.333334 117.333333v297.92z m-64-74.624V256a53.333333 53.333333 0 0 0-53.333334-53.333333H202.666667a53.333333 53.333333 0 0 0-53.333334 53.333333v344.48A290.090667 290.090667 0 0 1 192 597.333333a286.88 286.88 0 0 1 183.296 65.845334C427.029333 528.384 556.906667 437.333333 704 437.333333c65.706667 0 126.997333 16.778667 170.666667 41.962667z m0 82.24c-5.333333-8.32-21.130667-21.653333-43.648-32.917333C796.768 511.488 753.045333 501.333333 704 501.333333c-121.770667 0-229.130667 76.266667-270.432 188.693334-2.730667 7.445333-7.402667 20.32-13.994667 38.581333-7.68 21.301333-34.453333 28.106667-51.370666 13.056-16.437333-14.634667-28.554667-25.066667-36.138667-31.146667A222.890667 222.890667 0 0 0 192 661.333333c-14.464 0-28.725333 1.365333-42.666667 4.053334V768a53.333333 53.333333 0 0 0 53.333334 53.333333h618.666666a53.333333 53.333333 0 0 0 53.333334-53.333333V561.525333zM320 480a96 96 0 1 1 0-192 96 96 0 0 1 0 192z m0-64a32 32 0 1 0 0-64 32 32 0 0 0 0 64z" fill="#3b62f8" p-id="2756"></path></svg>
                        </div>
                        <div class="file-view" @click="handleSatisfiedScale(item)">
                            <svg t="1742437967417" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18483" width="20" height="18"><path d="M876.08888889 2.27555555H147.91111111c-80.09955555 0-145.63555555 65.536-145.63555556 145.63555556v728.17777778c0 80.09955555 65.536 145.63555555 145.63555556 145.63555556h728.17777778c80.09955555 0 145.63555555-65.536 145.63555556-145.63555556V147.91111111c0-80.09955555-65.536-145.63555555-145.63555556-145.63555556zM293.54666667 839.68c0 20.02488889-16.384 36.40888889-36.40888889 36.40888889h-72.81777778c-20.02488889 0-36.40888889-16.384-36.40888889-36.40888889V475.59111111c0-20.02488889 16.384-36.40888889 36.40888889-36.40888889h72.81777778c20.02488889 0 36.40888889 16.384 36.40888889 36.40888889v364.08888889z m291.95377778 0c0 20.02488889-16.384 36.40888889-36.4088889 36.40888889h-72.81777777c-20.02488889 0-36.40888889-16.384-36.40888889-36.40888889V329.95555555c0-20.02488889 16.384-36.40888889 36.40888889-36.40888888h72.81777777c20.02488889 0 36.40888889 16.384 36.4088889 36.40888888v509.72444445z m290.58844444 0c0 20.02488889-16.384 36.40888889-36.40888889 36.40888889h-72.81777778c-20.02488889 0-36.40888889-16.384-36.40888889-36.40888889V402.77333333c0-20.02488889 16.384-36.40888889 36.40888889-36.40888888h72.81777778c20.02488889 0 36.40888889 16.384 36.40888889 36.40888888v436.90666667z" fill="#3b62f8" p-id="18484"></path></svg>
                        </div>
                    </div>
                </div>
                <!--其他量表 -->
                <div class="info-column-container" style="margin-top: 10px;" v-if="scaleList2&&scaleList2.length>0">
                    <div class="column-title">其他量表</div>
                </div>
                <div class="file-list">
                    <div class="file-item" v-for="item in scaleList2" :key="item">
                        <div class="file-title" @click="handleComplete(item)">{{item.title}}</div>
                        <div class="file-view" @click="handleComplete(item)">
                            <svg t="1742436699597" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2755" width="22" height="22"><path d="M938.666667 553.92V768c0 64.8-52.533333 117.333333-117.333334 117.333333H202.666667c-64.8 0-117.333333-52.533333-117.333334-117.333333V256c0-64.8 52.533333-117.333333 117.333334-117.333333h618.666666c64.8 0 117.333333 52.533333 117.333334 117.333333v297.92z m-64-74.624V256a53.333333 53.333333 0 0 0-53.333334-53.333333H202.666667a53.333333 53.333333 0 0 0-53.333334 53.333333v344.48A290.090667 290.090667 0 0 1 192 597.333333a286.88 286.88 0 0 1 183.296 65.845334C427.029333 528.384 556.906667 437.333333 704 437.333333c65.706667 0 126.997333 16.778667 170.666667 41.962667z m0 82.24c-5.333333-8.32-21.130667-21.653333-43.648-32.917333C796.768 511.488 753.045333 501.333333 704 501.333333c-121.770667 0-229.130667 76.266667-270.432 188.693334-2.730667 7.445333-7.402667 20.32-13.994667 38.581333-7.68 21.301333-34.453333 28.106667-51.370666 13.056-16.437333-14.634667-28.554667-25.066667-36.138667-31.146667A222.890667 222.890667 0 0 0 192 661.333333c-14.464 0-28.725333 1.365333-42.666667 4.053334V768a53.333333 53.333333 0 0 0 53.333334 53.333333h618.666666a53.333333 53.333333 0 0 0 53.333334-53.333333V561.525333zM320 480a96 96 0 1 1 0-192 96 96 0 0 1 0 192z m0-64a32 32 0 1 0 0-64 32 32 0 0 0 0 64z" fill="#3b62f8" p-id="2756"></path></svg>
                        </div>
                        <div class="file-view" @click="handleRateScale(item)">
                            <svg t="1742437967417" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="18483" width="20" height="18"><path d="M876.08888889 2.27555555H147.91111111c-80.09955555 0-145.63555555 65.536-145.63555556 145.63555556v728.17777778c0 80.09955555 65.536 145.63555555 145.63555556 145.63555556h728.17777778c80.09955555 0 145.63555555-65.536 145.63555556-145.63555556V147.91111111c0-80.09955555-65.536-145.63555555-145.63555556-145.63555556zM293.54666667 839.68c0 20.02488889-16.384 36.40888889-36.40888889 36.40888889h-72.81777778c-20.02488889 0-36.40888889-16.384-36.40888889-36.40888889V475.59111111c0-20.02488889 16.384-36.40888889 36.40888889-36.40888889h72.81777778c20.02488889 0 36.40888889 16.384 36.40888889 36.40888889v364.08888889z m291.95377778 0c0 20.02488889-16.384 36.40888889-36.4088889 36.40888889h-72.81777777c-20.02488889 0-36.40888889-16.384-36.40888889-36.40888889V329.95555555c0-20.02488889 16.384-36.40888889 36.40888889-36.40888888h72.81777777c20.02488889 0 36.40888889 16.384 36.4088889 36.40888888v509.72444445z m290.58844444 0c0 20.02488889-16.384 36.40888889-36.40888889 36.40888889h-72.81777778c-20.02488889 0-36.40888889-16.384-36.40888889-36.40888889V402.77333333c0-20.02488889 16.384-36.40888889 36.40888889-36.40888888h72.81777778c20.02488889 0 36.40888889 16.384 36.40888889 36.40888888v436.90666667z" fill="#3b62f8" p-id="18484"></path></svg>
                        </div>
                    </div>
                </div>

                <!--附件内容 -->
                <div class="info-column-container" style="margin-top: 10px;" v-if="lessonInfo.fileList&&lessonInfo.fileList.length>0">
                    <div class="column-title">培训附件</div>
                </div>
                <div class="file-list">
                    <div class="file-item" v-for="item in lessonInfo.fileList" :key="item">
                        <div class="file-title">{{item.fileName}}</div>
                        <div class="file-view">
                            <el-image @click="handleFIleStatus(item.status)" class="file-icon" style="margin-top: 2px"
                                      :src="require('@/assets/file/file_view_color.png')"
                                      :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                            </el-image>
                        </div>
                        <div class="file-view" @click="downloadFile(item)">
                            <svg t="1742438760961" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="20003" width="24" height="22"><path d="M867.705263 485.519719v359.298246h-718.596491v-359.298246h-71.859649v395.22807c0 19.761404 16.168421 35.929825 35.929824 35.929825h790.456141c19.761404 0 35.929825-16.168421 35.929824-35.929825v-395.22807h-71.859649z" p-id="20004" fill="#3b62f8"></path><path d="M508.407018 665.168842c8.982456 0 17.964912-3.592982 25.150877-10.778947l215.578947-215.578948-50.301754-50.301754-154.498246 154.498246v-452.71579h-71.859649v452.71579l-154.498246-154.498246-50.301754 50.301754 215.578947 215.578948c7.185965 7.185965 16.168421 10.778947 25.150878 10.778947z" p-id="20005" fill="#3b62f8"></path></svg>
                        </div>
                    </div>
                </div>

            </div>
            <!--讨论区-->
            <div class="right-container">
                <div class="discuss-title-box">
                    培训交流区
                </div>
                <div class="discuss-sub-box" >
                    <div class="discuss-info">
                        <el-input
                          type="textarea"
                          @focus="focusInput"
                          resize="none"
                          placeholder="请输入讨论内容"
                          v-model="discussWordContent"
                          autofocus
                          class="discuss-info-input"
                        >
                        </el-input>
                    </div>
                    <div class="discuss-btn-box">
                        <div class="limit">
                            <el-upload class="discuss-uploader"
                                       :action="serviceUrl+'/businessservice/evaluation/discussAnnex'"
                                       :show-file-list="false"
                                       :on-success="handleUploadFileSuccess"
                                       :headers="{ token }"
                                       accept=".doc,.docx,.ppt,.pptx,.pdf"
                                       :before-upload="beforeFileUpload">

                                <img class="icon-upload-img" alt="上传附件" src="../../assets/icon/img/upload_file1.png">
                            </el-upload>
                        </div>

                        <div class="limit">
                            <el-upload class="discuss-uploader"
                                       :action="serviceUrl+'/businessservice/evaluation/discussAnnex'"
                                       :show-file-list="false"
                                       :on-success="handleUploadImageSuccess"
                                       :headers="{ token }"
                                       accept=".png,.jpeg,.jpg"
                                       :before-upload="beforeImageUpload">
                                <img class="icon-upload-img" alt="上传图片" src="../../assets/icon/img/upload_img1.png">
                            </el-upload>
                        </div>
                        <el-button type="primary" style="margin-left: 120px;" round @click="submitDiscuss">
                            发表
                        </el-button>
                    </div>
                </div>
                <el-scrollbar class="discuss-show-box">
                    <div class="discuss-one" v-for="item in discussList">
                        <div class="discuss-user-avatar">
                            <img class="discuss-user-avatar-img" alt="无" @error="onImageError" :src="item.avatar">
                        </div>
                        <div class="discuss-user-content">
                            <div class="user-info">
                                <div class="flex-item user-true-name">{{item.createUserName}}</div>
                                <div class="flex-item user-role">
                                    <div class="role2" v-show="item.roleType===0">参与人</div>
                                </div>
                                <div class="flex-item content-time">{{timestampToTime(item.createTime)}}</div>
                            </div>
                            <div class="content-info" v-if="item.discussType===1">
                                {{item.content}}
                            </div>
                            <div class="img-info" v-if="item.discussType===2">
                                <el-image alt="" :src="item.imgContent"
                                          :preview-src-list="item.imgList" ></el-image>
                            </div>
                            <div class="audio-info" v-if="item.discussType===3">
                                <audio controls controlslist="nodownload noplaybackrate" ref="audio">
                                    <source type="audio/mpeg" :src="item.audioContent" />
                                </audio>
                            </div>
                            <div class="file-info" v-if="item.discussType===4">
                                <div class="file-box">
                                    <div class="file-icon">
                                        <el-image @click="handleFIleStatus(item.file.status)" class="icon-image" v-if="comStr('pdf',item.file.fileType)"
                                                  :src="require('@/assets/icon/img/file-pdf@3x.png')"
                                                  :preview-src-list="gainFileImgList(item.file.imgUrl,item.file.pages)">
                                        </el-image>
                                        <el-image @click="handleFIleStatus(item.file.status)" class="icon-image" v-if="comStr('doc',item.file.fileType)"
                                                  :src="require('@/assets/icon/img/file-doc@3x.png')"
                                                  :preview-src-list="gainFileImgList(item.file.imgUrl,item.file.pages)">
                                        </el-image>
                                        <el-image @click="handleFIleStatus(item.file.status)" class="icon-image" v-if="comStr('ppt',item.file.fileType)"
                                                  :src="require('@/assets/icon/img/file-ppt@3x.png')"
                                                  :preview-src-list="gainFileImgList(item.file.imgUrl,item.file.pages)">
                                        </el-image>
                                        <el-image @click="handleUnKnow" class="icon-image" v-if="!comStr('ppt',item.file.fileType)&&!comStr('doc',item.file.fileType)&&!comStr('pdf',item.file.fileType)"
                                                  :src="require('@/assets/icon/img/file-unknown@3x.png')"
                                                  :preview-src-list="gainFileImgList(item.file.imgUrl,item.file.pages)">
                                        </el-image>
                                    </div>
                                    <div class="file-detail">
                                        <div class="name-box" @click.stop="handleDownload(item.file.fileUrl,item.file.fileName)">{{item.file.fileName}}</div>
                                        <div class="size-box">
                                            <div class="size-num">{{item.file.fileSize}}</div>
                                            <div class="file-view">
                                                <img alt="" src="@/assets/icon/img/download.png" @click.stop="handleDownload(item.file.fileUrl,item.file.fileName)">
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="discussList.length===0" class="data-empty">
                        <div class="empty-icon"><img src="../../assets/icon/img/data_empty.png" /></div>
                        <div class="empty-title">暂无数据</div>
                    </div>
                </el-scrollbar>

            </div>
        </div>

        <!--编辑-->
        <div class="lesson-edit-container" v-show="this.showMode==='edit'">
            <div class="top-title">培训任务编辑</div>
            <el-form ref="form" :model="lessonInfo" :rules="rules" label-width="120px">
                <el-row>
                    <el-col :span="15">
                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="任务标题" prop="title">
                                    <el-input v-model="lessonInfo.title" placeholder="最多32个字" maxlength="32" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="培训性质" prop="trainNature">
                                    <el-select @change="changeLessonNature" style="width: 100%;" v-model="lessonInfo.trainNature"
                                               placeholder="请选择备课性质">
                                        <el-option v-for="item in natureList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.trainNature !== '1'">
                            <el-col :span="23">
                                <el-form-item :label="lessonInfo.trainNature === '4' ? '群组' : '工作室'" prop="groupId">
                                    <el-select @change="changeQun" style="width: 100%;" v-model="lessonInfo.groupId"
                                               placeholder="请选择工作室/群组">
                                        <el-option v-for="item in groupList" :key="item.groupId" :label="item.groupName"
                                                   :value="item.groupId" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="开放评论" prop="isComment">
                                    <el-switch
                                      v-model="lessonInfo.isComment"
                                      inline-prompt
                                      active-text="是"
                                      inactive-text="否"
                                      active-value="1"
                                      inactive-value="0"
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="培训类型" prop="classify">
                                    <el-select style="width: 100%;" v-model="lessonInfo.classify"
                                               placeholder="请选择培训类型">
                                        <el-option v-for="item in courseClassifyList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="培训形式" prop="type">
                                    <el-radio-group v-model="lessonInfo.type">
                                        <el-radio :label="2">现场培训</el-radio>
                                        <el-radio :label="0">直播培训</el-radio>
                                        <el-radio :label="1">录播培训</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.type === 1">
                            <el-col :span="23">
                                <el-form-item label="录播类型" prop="lbType">
                                    <el-radio-group v-model="lessonInfo.lbType">
                                        <el-radio :label="0">培训课程</el-radio>
                                        <el-radio :label="1">本地上传</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row  v-if="lessonInfo.type == 0">
                            <el-col :span="23">
                                <el-col :span="12">
                                    <el-form-item label="直播地址" prop="linkUrl">
                                        <el-input v-model="lessonInfo.linkUrl" placeholder="请输入直播地址,最多256个字" maxlength="256" />
                                    </el-form-item>
                                </el-col>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.type == 1 && lessonInfo.lbType==0">
                            <el-col :span="23">
                                <el-col :span="12">
                                    <el-form-item label="培训课程" prop="courseIds">
                                        <selectTrainCourse
                                          :showTitle="'选择培训课程'"
                                          :selCourseId="lessonInfo.courseIds"
                                          ref="selCourseId" />
                                    </el-form-item>
                                </el-col>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.type == 1 && lessonInfo.lbType==1">
                            <el-col :span="23">
                                <el-col :span="12">
                                    <el-form-item label="本地视频" prop="videoUrl">
                                        <el-input v-model="lessonInfo.videoUrl" placeholder="请输入视频网址或上传本地视频" maxlength="256">
                                            <template #append>
                                                <el-button @click="showUpload">上传视频</el-button>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="任务时段" prop="formTime">
                                    <el-col :span="11" class="date_picker">
                                        <el-date-picker format="YYYY-MM-DD HH:mm" @change="startDateConfirm"
                                                        :disabled-date="disabledDate" style="width: 100%;" v-model="lessonInfo.beginTime"
                                                        type="datetime" placeholder="开始时间" value-format="x" />
                                    </el-col>
                                    <el-col :span="2" class="text-center">
                                        <span class="text-gray-500">至</span>
                                    </el-col>
                                    <el-col :span="11">
                                        <el-date-picker format="YYYY-MM-DD HH:mm" class="date_picker" @change="endDateConfirm"
                                                        style="width: 100%;" v-model="lessonInfo.endTime"
                                                        type="datetime" placeholder="结束时间" value-format="x" />
                                    </el-col>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.type == 2">
                            <el-col :span="23">
                                <el-form-item label="打卡次数" prop="signCount">
                                    <el-radio-group v-model="lessonInfo.signCount">
                                        <el-radio :label="2">2</el-radio>
                                        <el-radio :label="4">4</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.type == 2">
                            <el-col :span="23">
                                <el-form-item label="签到时间" prop="signInTime">
                                    <el-time-picker format="HH:mm" @change="startsignInConfirm" value-format="x"
                                                    v-model="lessonInfo.signInBeginTime" placeholder="开始时间" />
                                    <div style="padding: 0 15px 0 15px ;">至</div>
                                    <el-time-picker format="HH:mm" @change="endsignInConfirm" value-format="x"
                                                    v-model="lessonInfo.signInEndTime" placeholder="结束时间" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.type == 2">
                            <el-col :span="23">
                                <el-form-item label="签退时间" prop="signOutTime">
                                    <el-time-picker format="HH:mm" @change="startsignOutConfirm" value-format="x"
                                                    v-model="lessonInfo.signOutBeginTime" placeholder="开始时间" />
                                    <div style="padding: 0 15px 0 15px ;">至</div>
                                    <el-time-picker format="HH:mm" @change="endsignOutConfirm" value-format="x"
                                                    v-model="lessonInfo.signOutEndTime" placeholder="结束时间" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.type == 2 && lessonInfo.signCount == 4">
                            <el-col :span="23">
                                <el-form-item label="二次签到时间" prop="secondSignInTime">
                                    <el-time-picker format="HH:mm" @change="startSecondsignInConfirm" value-format="X"
                                                    v-model="lessonInfo.secondSignInBeginTime" placeholder="开始时间" />
                                    <div style="padding: 0 15px 0 15px ;">至</div>
                                    <el-time-picker format="HH:mm" @change="endSecondsignInConfirm" value-format="x"
                                                    v-model="lessonInfo.secondSignInEndTime" placeholder="结束时间" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.type == 2 && lessonInfo.signCount == 4">
                            <el-col :span="23">
                                <el-form-item label="二次签退时间" prop="secondSignOutTime">
                                    <el-time-picker format="HH:mm" @change="startSecondsignOutConfirm" value-format="x"
                                                    v-model="lessonInfo.secondSignOutBeginTime" placeholder="开始时间" />
                                    <div style="padding: 0 15px 0 15px ;">至</div>
                                    <el-time-picker format="HH:mm" @change="endSecondsignOutConfirm" value-format="x"
                                                    v-model="lessonInfo.secondSignOutEndTime" placeholder="结束时间" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.type == 2">
                            <el-col :span="23">
                                <el-form-item label="签到总次数(次)" prop="signTotalCount">
                                    <el-input-number v-model="lessonInfo.signTotalCount" step-strictly :min="1" :max="100000" />
                                    <span style="color: red;" class="ml15">*签到+签退为一次打卡</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.type == 2">
                            <el-col :span="23">
                                <el-form-item label="签到地址" prop="signInAddress">
                                    <el-input v-model="lessonInfo.signInAddress" placeholder="最多32个字" maxlength="32" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.type == 2">
                            <el-col :span="23">
                                <el-form-item label="签到范围(m)" prop="signInDistance">
                                    <el-input-number v-model="lessonInfo.signInDistance" step-strictly :min="1000" :max="100000" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="lessonInfo.type == 2">
                            <el-col :span="23">
                                <el-form-item label="" v-show="lessonInfo.type === 2">
                                    <aMap v-if="isShowMap"
                                          ref="zdyMap1"
                                          style="width: 660px"
                                          @getGeocoder="getGeocoder"
                                          :oldCenter="oldCenter"
                                          :isShowAMap="true">
                                    </aMap>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="培训级别" prop="trainLevel">
                                    <el-select style="width: 100%;" v-model="lessonInfo.trainLevel" placeholder="请选择课题级别">
                                        <el-option v-for="item in lessonLevelList" :key="item.dictKey" :label="item.dictValue"
                                                   :value="item.dictKey" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="班主任" prop="leadTeacherList">
                                    <choosePeople :showTitle="'选择班主任'" ref="leadTeacherList" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="副班主任" prop="viceLeadTeacherList">
                                    <choosePeople :showTitle="'选择副班主任'" ref="viceLeadTeacherList" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="参与人员" prop="joinUsersList">
                                    <choosePeople :showTitle="'选择培训参与人员'" ref="joinUsersList" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="满意度量表" prop="satisfiedScale">
                                    <el-select style="width:100%" filterable v-model="lessonInfo.satisfiedScale"
                                               placeholder="请选择满意度调查量表">
                                        <el-option v-for="item in satisfiedScaleList" :key="item.scaleId" :label="item.title"
                                                   :value="item.scaleId">
                                            <span style="float: left">{{ item.title }}</span>
                                            <span @click.stop="preview(item)" style="float: right; color: #8492a6; font-size: 13px">
                                    <el-icon>
                                        <View />
                                    </el-icon></span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="其他量表" prop="scaleIds">
                                    <el-select style="width:100%" multiple filterable v-model="lessonInfo.scaleList"
                                               placeholder="请选择量表">
                                        <el-option v-for="item in rateScaleList" :key="item.scaleId" :label="item.title"
                                                   :value="item.scaleId">
                                            <span style="float: left">{{ item.title }}</span>
                                            <span @click.stop="preview(item)" style="float: right; color: #8492a6; font-size: 13px">
                                    <el-icon>
                                        <View />
                                    </el-icon></span>
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="培训内容" prop="content">
                                    <el-input type="textarea" v-model="lessonInfo.content" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="23">
                                <el-form-item label="上传附件" prop="">
                                    <el-upload v-model:file-list="fileList" class="upload-demo" :on-remove="handleRemove"
                                               :action="serviceUrl+'/businessservice/train/uploadFile'"
                                               :on-change="handleJAChange" :headers="{ token }" accept=".pdf,.ppt,.pptx,.doc,.docx"
                                               :before-upload="beforeJAUpload">
                                        <el-button type="primary">点击上传</el-button>
                                        <template #tip>
                                            <div class="el-upload__tip">
                                                只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。
                                            </div>
                                        </template>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-col>




                    <el-col :span="9">
                        <el-form-item label="任务封面" prop="coverUrl">
                            <el-upload class="avatar-uploader"
                                       :action="serviceUrl+'/businessservice/train/uploadCover'"
                                       :show-file-list="false" :on-success="handleCoverSuccess" :headers="{ token }"
                                       :before-upload="beforeCoverUpload">
                                <img alt v-if="lessonInfo.coverUrl" :src="lessonInfo.coverUrl" class="avatar" style="position:absolute" />
                                <el-icon v-else class="avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                    <Plus />
                                </el-icon>
                            </el-upload>
                            <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="disflex-row-center">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="submitForm">保 存</el-button>
            </div>
        </div>

        <el-dialog :title="'培训量表'" v-model="previewShow" width="60%">
            <previewData :disabled="disabled" ref="editData" v-if="previewShow" :previewData="previewData" :isHide="isHide">
            </previewData>
            <template #footer v-if="!disabled">
                <div class="disflex-row-center">
                    <el-button type="primary" @click="submitPreviewForm">确 定</el-button>
                    <el-button @click="closePreview">取 消</el-button>
                </div>
            </template>
        </el-dialog>



        <!--量表统计-->
        <el-dialog  v-model="isRateScaleShow" width="640px" :show-close="false">
            <el-descriptions :column="3" :title="'量表统计'" border style="margin-top: -15px">
                <template #extra>
                    <el-dropdown v-if="scaleStatsList && scaleStatsList.length > 0" slot="dropdown">
                        <el-tag type="primary" style="height: 24px;border: 1px solid #1f89de;line-height: 24px;color: #1f89de">
                            ⇅ {{scaleTitle}}
                        </el-tag>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item :disabled="scaleId==item.scaleId" v-for="item in scaleStatsList" @click="changeScale(item)">{{item.title}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                    <el-tag style="margin-left: 10px" class="homework_tag cursor" @click="this.isRateScaleShow=!this.isRateScaleShow" >关闭</el-tag>
                </template>
            </el-descriptions>
            <el-tabs v-model="activeTabName" @tab-click="handleTabsClick" type="border-card"
                     style="margin-top: -5px">
                <el-tab-pane label="统计结果" name="0" >
                    <div v-if="questionList.length===0" class="data-empty">
                        <div class="empty-icon"><img src="../../assets/icon/img/data_empty.png" /></div>
                        <div class="empty-title">暂无数据</div>
                    </div>
                    <div v-for="(item,index) in questionList" :style="index==0?'margin-top:-10px;':''">
                        <h3 style="margin: 10px 0 10px 0;">
                            <span>
                                {{ index + 1 }}.{{item.questionName }}
                            </span>
                            <span style="height:22px;line-height:22px;color: #999;font-weight: normal;font-size: 14px;">
                                [{{item.type == 1 ? '单选' : item.type == 2 ? '多选' : item.type == 3 ? '评分' : item.type == 4 ? '文字内容' : '' }}]
                            </span>
                        </h3>
                        <el-table v-if="item.type==1 || item.type==2"
                                  :data="item.answerList"
                                  :row-class-name="hideStat"
                                  border fit>
                            <el-table-column  align="center" label="选项" prop="itemName"/>
                            <el-table-column  align="center" label="小计" prop="answerCount"/>
                            <el-table-column  align="center" label="比例" prop="rate">
                                <template #default="scope">
                                    <div>{{scope.row.rate * 100}}%</div>
                                </template>
                            </el-table-column>
                            <template #append>
                                <div style="display: flex">
                                    <div style="width: 100%;height: 40px;line-height: 40px;font-weight: bold;text-align: center;">
                                        本题有效填写人次：{{item.count}}
                                    </div>
                                </div>
                            </template>
                        </el-table>
                        <div class="chart-tab" v-if="item.type!=3 && item.type!=4">
                            <ul class="fr">
                                <li @click="handlePieQuestion(item.questionId)" :class="this.pieQuIds.includes(item.questionId)?'liSel':''">
                                    饼状
                                </li>
                                <li @click="handleBarQuestion(item.questionId)" :class="this.barQuIds.includes(item.questionId)?'liSel':''">
                                    柱状
                                </li>
                            </ul>
                        </div>

                        <pieEcharts v-if="item.type!=3 && item.type!=4 && this.pieQuIds.includes(item.questionId)"
                                    :id="item.questionId+'_pie'"
                                    :dataList="item.answerList"/>

                        <barEcharts v-if="item.type!=3 && item.type!=4 && this.barQuIds.includes(item.questionId)"
                                    :id="item.questionId+'_bar'"
                                    :dataList="item.answerList"/>


                        <el-table v-if="item.type==3" :data="item.aveScore" border fit>
                            <el-table-column  align="center" label="打分人数" prop="trueName">
                                <div>{{item.count}}</div>
                            </el-table-column>
                            <el-table-column  align="center" label="平均分" >
                                <template #default="scope">
                                    <div>{{scope.row}}</div>
                                </template>
                            </el-table-column>
                        </el-table>

                        <el-table v-if="item.type==4" :data="item.userAnswerList" border fit>
                            <el-table-column  align="center" label="姓名" prop="trueName">
                                <template #default="scope">
                                    <div>{{scope.row.isHide==0?scope.row.trueName:'匿名'}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column  align="center" label="内容" prop="answerName" />
                        </el-table>

                    </div>
                </el-tab-pane>
                <el-tab-pane label="详细数据" name="1" >
                    <div v-if="userRecordList.length===0" class="data-empty">
                        <div class="empty-icon"><img src="../../assets/icon/img/data_empty.png" /></div>
                        <div class="empty-title">暂无数据</div>
                    </div>
                    <el-collapse v-if="userRecordList.length!==0" v-model="activeNames" accordion>
                        <el-collapse-item v-for="(item,index) in userRecordList" :name="index+1"
                                          @click.native="handleChange(index)">
                            <template #title>
                                <h3 style="margin: 0 0;" :class="activeIndex==index?'user-record-title active':'user-record-title'">
                                    {{item.isHide==0?(index+1)+'.'+item.trueName:(index+1) +'.匿名'}} 提交时间: {{timestampToTime(item.submitTime)}}
                                </h3>
                            </template>
                            <div v-for="(q,i) in item.questionList">
                                <h3 style="margin: 10px 0 10px 0;color:#909399 ">
                                    <span>
                                        {{ i + 1 }}.{{q.questionName }}
                                    </span>
                                    <span style="height:22px;line-height:22px;color: #999;font-weight: normal;font-size: 14px;">
                                        [{{q.type == 1 ? '单选' : q.type == 2 ? '多选' : q.type == 3 ? '评分' : q.type == 4 ? '文字内容' : '' }}]
                                    </span>
                                </h3>
                                <div style="margin-left: 10px">
                                    {{q.questionAnswer}}
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>

        <el-dialog  v-model="isSatisfiedShow" width="640px" :show-close="false">
            <el-descriptions :column="3" :title="'满意度调查统计'" border style="margin-top: -15px">
                <template #extra>
                    <el-tag style="margin-left: 10px" class="homework_tag cursor" @click="this.isSatisfiedShow=!this.isSatisfiedShow" >关闭</el-tag>
                </template>
            </el-descriptions>
            <el-tabs v-model="activeTabName" @tab-click="handleTabsClick" type="border-card"
                     style="margin-top: -5px">
                <el-tab-pane label="统计结果" name="0" >
                    <div v-if="questionList.length===0" class="data-empty">
                        <div class="empty-icon"><img src="../../assets/icon/img/data_empty.png" /></div>
                        <div class="empty-title">暂无数据</div>
                    </div>
                    <div v-for="(item,index) in questionList" :style="index==0?'margin-top:-10px;':''">
                        <h3 style="margin: 10px 0 10px 0;">
                            <span>
                                {{ index + 1 }}.{{item.questionName }}
                            </span>
                            <span style="height:22px;line-height:22px;color: #999;font-weight: normal;font-size: 14px;">
                                [{{item.type == 1 ? '单选' : item.type == 2 ? '多选' : item.type == 3 ? '评分' : item.type == 4 ? '文字内容' : '' }}]
                            </span>
                        </h3>
                        <el-table v-if="item.type==1 || item.type==2"
                                  :data="item.answerList"
                                  :row-class-name="hideStat"
                                  border fit>
                            <el-table-column  align="center" label="选项" prop="itemName"/>
                            <el-table-column  align="center" label="小计" prop="answerCount"/>
                            <el-table-column  align="center" label="比例" prop="rate">
                                <template #default="scope">
                                    <div>{{scope.row.rate * 100}}%</div>
                                </template>
                            </el-table-column>
                            <template #append>
                                <div style="display: flex">
                                    <div style="width: 100%;height: 40px;line-height: 40px;font-weight: bold;text-align: center;">
                                        本题有效填写人次：{{item.count}}
                                    </div>
                                </div>
                            </template>
                        </el-table>
                        <div class="chart-tab" v-if="item.type!=3 && item.type!=4">
                            <ul class="fr">
                                <li @click="handlePieQuestion(item.questionId)" :class="this.pieQuIds.includes(item.questionId)?'liSel':''">
                                    饼状
                                </li>
                                <li @click="handleBarQuestion(item.questionId)" :class="this.barQuIds.includes(item.questionId)?'liSel':''">
                                    柱状
                                </li>
                            </ul>
                        </div>

                        <pieEcharts v-if="item.type!=3 && item.type!=4 && this.pieQuIds.includes(item.questionId)"
                                    :id="item.questionId+'_pie'"
                                    :dataList="item.answerList"/>

                        <barEcharts v-if="item.type!=3 && item.type!=4 && this.barQuIds.includes(item.questionId)"
                                    :id="item.questionId+'_bar'"
                                    :dataList="item.answerList"/>


                        <el-table v-if="item.type==3" :data="item.aveScore" border fit>
                            <el-table-column  align="center" label="打分人数" prop="trueName">
                                <div>{{item.count}}</div>
                            </el-table-column>
                            <el-table-column  align="center" label="平均分" >
                                <template #default="scope">
                                    <div>{{scope.row}}</div>
                                </template>
                            </el-table-column>
                        </el-table>

                        <el-table v-if="item.type==4" :data="item.userAnswerList" border fit>
                            <el-table-column  align="center" label="姓名" prop="trueName">
                                <template #default="scope">
                                    <div>{{scope.row.isHide==0?scope.row.trueName:'匿名'}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column  align="center" label="内容" prop="answerName" />
                        </el-table>

                    </div>
                </el-tab-pane>
                <el-tab-pane label="详细数据" name="1" >
                    <div v-if="userRecordList.length===0" class="data-empty">
                        <div class="empty-icon"><img src="../../assets/icon/img/data_empty.png" /></div>
                        <div class="empty-title">暂无数据</div>
                    </div>
                    <el-collapse v-if="userRecordList.length!==0" v-model="activeNames" accordion>
                        <el-collapse-item v-for="(item,index) in userRecordList" :name="index+1"
                                          @click.native="handleChange(index)">
                            <template #title>
                                <h3 style="margin: 0 0;" :class="activeIndex==index?'user-record-title active':'user-record-title'">
                                    {{item.isHide==0?(index+1)+'.'+item.trueName:(index+1) +'.匿名'}} 提交时间: {{timestampToTime(item.submitTime)}}
                                </h3>
                            </template>
                            <div v-for="(q,i) in item.questionList">
                                <h3 style="margin: 10px 0 10px 0;color:#909399 ">
                                    <span>
                                        {{ i + 1 }}.{{q.questionName }}
                                    </span>
                                    <span style="height:22px;line-height:22px;color: #999;font-weight: normal;font-size: 14px;">
                                        [{{q.type == 1 ? '单选' : q.type == 2 ? '多选' : q.type == 3 ? '评分' : q.type == 4 ? '文字内容' : '' }}]
                                    </span>
                                </h3>
                                <div style="margin-left: 10px">
                                    {{q.questionAnswer}}
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>

        <el-dialog :title="'作业管理'" v-model="isHomeworkShow" width="800px">
            <el-table :data="homeworkList"
                      v-loading="loading"
                      show-overflow-tooltip
                      highlight-current-row>
                <el-table-column type="index" label="序号" align="center" width="60" />
                <el-table-column width="150" label="作业标题" align="center" prop="title">
                    <template #default="scope">
                        <div :title="scope.row.title" style="color: #409efe;" class="text-one cursor">
                            {{ scope.row.title }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="200" label="作业内容" align="center" prop="content"></el-table-column>
                <el-table-column width="140" label="截止时间" align="center" prop="endTime">
                    <template #default="scope">
                        <div>{{ timestampToTime(scope.row.endTime) }}</div>
                    </template>
                </el-table-column>
                <el-table-column width="100" label="作业附件" align="center" prop="" >
                    <template #default="scope">
                        <el-popover placement="bottom-start" :width="125"
                                    trigger="click" :min-width="'auto'">
                            <div v-if="scope.row.fileList.length != 0">
                                <div>
                                    <div style="display: flex;align-items:center;"
                                         v-for="(item, index) in scope.row.fileList">
                                        <div :title="item.fileName"
                                             class="filtxt text-one cursor">
                                            {{ index + 1 }}. {{ item.fileName }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <template #reference>
                                <div style="color: #409efe;" class="cursor">
                                    {{ scope.row.fileList.length }}
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column width="100" label="操作" align="center" prop="">
                    <template #default="scope">
                        <el-popover placement="bottom" trigger="click" :width="80" popper-style="padding: 5px 0 0">
                            <template #reference>
                                <el-button>操作</el-button>
                            </template>
                            <template #default>
                                <div class="text-item">
                                    <el-text type="primary" @click="handleFinish(scope.row)">完成情况</el-text>
                                </div>
                                <el-popconfirm confirm-button-text="是" cancel-button-text="否" :icon="InfoFilled"
                                               icon-color="#626AEF" title="确定删除该作业?" @confirm="handleDeleteHomework(scope.row)">
                                    <template #reference>
                                        <div class="text-item">
                                            <el-text type="primary">删除</el-text>
                                        </div>
                                    </template>
                                </el-popconfirm>

                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
            <el-row style="margin-top:20px" justify="center">
                <el-button type="primary" @click="arrangeHomework">布置作业</el-button>
            </el-row>
        </el-dialog>

        <el-dialog title="发布作业" v-model="isHomeworkEditShow" width="650px">
            <el-form ref="homeworkForm" :model="homeworkForm" :rules="homeworkFormRules">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label-width="80px" label="作业标题" prop="title">
                            <el-input
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写作业标题"
                              v-model="homeworkForm.title"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label-width="80px" label="作业内容" prop="content">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写作业内容"
                              v-model="homeworkForm.content"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-form-item class="pull-right" label-width="80px" label="截止时间" prop="endTime">
                        <el-date-picker
                          v-model="homeworkForm.endTime"
                          type="datetime"
                          style="width: 160px;"
                          format="YYYY-MM-DD HH:mm"
                          placeholder="作业截止时间"
                          clearable/>
                    </el-form-item>
                </el-row>
                <el-row >
                    <el-col :span="24">
                        <el-form-item label-width="80px" label="作业附件" prop="">
                            <el-upload v-model:file-list="homeworkFileList"
                                       class="upload-demo"
                                       style="width: 260px"
                                       :on-remove="handleRemoveHomeworkFile"
                                       :action="serviceUrl+'/businessservice/homework/annexUpload'"
                                       :on-change="handleChangeHomeworkFile" :headers="{ token }"
                                       :before-upload="beforeUploadHomeworkFile">
                                <el-button type="primary">点击上传</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>

                </el-row>
            </el-form>
            <template #footer>
                <div class="disflex-row-center">
                    <el-button type="primary" @click="submitHomeworkForm">确 定</el-button>
                    <el-button @click="arrangeHomework">取 消</el-button>
                </div>
            </template>
        </el-dialog>

        <el-dialog title="提交作业" v-model="isHomeworkFinishShow" width="650px">
            <el-form ref="homeworkFinishForm" :model="homeworkFinishForm" :rules="homeworkFinishFormRules">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label-width="80px" label="培训作业" prop="homeworkId">
                            <el-select style="width: 100%;"
                                       v-model="homeworkFinishForm.homeworkId"
                                       @change="homeworkFinishInfo($event)"
                                       placeholder="请选择作业">
                                <el-option v-for="item in selHomeworkList" :key="item.homeworkId" :label="item.title"
                                           :value="item.homeworkId" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label-width="80px" label="作业内容" prop="content">
                            <el-input
                              type="textarea"
                              @focus="focusInput"
                              resize="none"
                              placeholder="请填写作业内容"
                              v-model="homeworkFinishForm.content"
                              autofocus
                              class="discuss-info-input">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row >
                    <el-col :span="24">
                        <el-form-item label-width="80px" label="作业附件" prop="">
                            <el-upload v-model:file-list="homeworkFinishFileList"
                                       class="upload-demo"
                                       style="width: 260px"
                                       :on-remove="handleRemoveHomeworkFile"
                                       :on-preview="handlePreviewHomeworkFile"
                                       :action="serviceUrl+'/businessservice/homework/annexUpload'"
                                       :on-change="handleChangeHomeworkFile" :headers="{ token }"
                                       :before-upload="beforeUploadHomeworkFile">
                                <el-button type="primary">点击上传</el-button>
                            </el-upload>
                        </el-form-item>
                    </el-col>

                </el-row>

            </el-form>
            <template #footer>
                <div class="disflex-row-center">
                    <el-button type="primary" @click="submitHomeworkFinishForm">确 定</el-button>
                    <el-button @click="arrangeHomeworkFinish">取 消</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import vueQr from 'vue-qr/src/packages/vue-qr.vue'
import {timestampToDate, timestampToTime} from "@/utils/date";
import {
    evaluationStop,
    evaluationUpdate,
    rateRecordScore, rateRecordScoreInfo,
    rateScaleInfo,
    rateScaleList
} from "@/api/admin/evaluation"
import {downloadFile} from "@/api/adminservice/public";
import {groupListAuthGroup, queryDict} from "@/api/admin/public";
import {serviceUrl, serviceWebUrl} from "@/utils/global"
import {orgListSchoolOrg, listUserManagerOrg} from "@/api/admin/system";
import choosePeople from "@/components/choosePeople.vue";
import html2canvas from "html2canvas";
import aMap from "@/components/aMap/index.vue";
import {ElLoading} from "element-plus";
import {getFileNameUUID, signatureUrl} from "@/utils/tools";
import selectLessonFile from "@/components/selectLessonFile.vue";
import previewData from "@/components/previewData.vue";
import barEcharts from "@/components/echart/barEcharts.vue";
import pieEcharts from "@/components/echart/pieEcharts.vue";
import {statsTrainRate, statsSatisfiedRate} from "@/api/admin/stats";
import {
    listTrainDiscuss,
    submitTrainDiscuss,
    trainCreate,
    trainDeleteFile,
    trainInfo, trainStop,
    trainUpdate
} from "@/api/admin/train";
import selectTrainCourse from "@/components/selectTrainCourse.vue";
import {
    homeworkCreate,
    homeworkDel,
    homeworkDelAnnex,
    homeworkFinish,
    homeworkFinishInfo,
    homeworkList, listHomeworkFinish, readOverHomework
} from "@/api/admin/homework";

export default {
    name: "teamLessonInfo",
    components: {
        selectTrainCourse,
        pieEcharts,
        barEcharts,
        selectLessonFile,
        aMap,
        choosePeople,
        vueQr,
        previewData
    },
    props:{
        trainId:{
            type: String,
            default:null,
        },
    },
    watch:{
        trainId(newValue,oldValue){
            this.queryLessonInfo()
            this.getDisList()
            this.getOrgListTypeOrg()
            this.getRateScaleList();
            // this.handleHomework()
        },
    },
    data() {
        return {
            loading: false,
            isShowMap: false,
            isTk: false,
            serviceUrl,
            token: this.$storage.get("token"),
            viewMode:'view',
            editMode:'edit',
            showMode:'view',
            timestampToTime,
            timestampToDate,
            lessonInfo:{
                coverUrl: 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/szpx.png',
                type: 2,
                classify:'',
                lbType:0,
                signCount: 2,
                title: '',
                trainNature: '1',
                joinUsersList: [],
                signInBeginTime: '',
                signInEndTime: '',
                signOutBeginTime: '',
                signOutEndTime: '',
                signInAddress: '',
                signInDistance: 1000,
                signTotalCount: 0,
                trainLevel: '',
                courseIds: '',
                linkUrl: '',
                videoUrl: '',
                beginTime: '',
                endTime: '',
                content: '',
                scaleIds: '',
                scaleList: [],
                satisfiedScale:'',
                isComment:0,
                groupId: '',
                secondSignInBeginTime: '',
                secondSignInEndTime: '',
                secondSignOutBeginTime: '',
                secondSignOutEndTime: '',
                leadTeacher:'',
                leadTeacherList:[],
                viceLeadTeacher:'',
                viceLeadTeacherList:[]
            },
            // 表单校验
            isDirectory: false,
            isCourse: false,
            periodList: [],
            gradeList: [],
            subjectList: [],
            directoryList: [],
            tableData: [],
            lessonLevelList:[],
            //删除文件
            delFileList: [],
            // 表单校验
            // 表单校验
            rules: {
                trainNature: [
                    { required: true, message: "请选择培训性质", trigger: "change" },
                ],
                classify: [
                    { required: true, message: "请选择培训类型", trigger: "change" },
                ],
                groupId: [
                    { required: true, message: "请选择工作室/群组", trigger: "change" },
                ],
                coverUrl: [
                    { required: true, validator: this.checkCoverValidator }
                ],
                type: [
                    { required: true, message: "请选择类型", trigger: "change" },
                ],
                signCount: [
                    { required: true, message: "请选择打卡次数", trigger: "change" },
                ],
                signTotalCount: [
                    { required: true, message: "请选择打卡次数", trigger: "change" },
                ],
                isComment: [
                    { required: true, message: "请选择是否开放评论", trigger: "change" },
                ],
                courseIds: [
                    { required: true, message: "请选择培训课程", trigger: "change" },
                ],
                satisfiedScale: [
                    { required: true, message: "请选择满意度调查表", trigger: "change" },
                ],
                title: [
                    { required: true, message: "请输入任务标题", trigger: "blur" },
                ],
                joinUsersList: [
                    { required: true, validator: this.checkjoinUsersList },
                ],
                content: [
                    { required: true, message: "请输入培训内容", trigger: "blur" },
                ],
                trainLevel: [
                    { required: true, message: "请选择培训级别", trigger: "change" },
                ],
                linkUrl: [
                    { required: true, message: "请输入线上培训地址", trigger: "blur" },
                ],
                videoUrl: [
                    { required: true, message: "请上传视频", trigger: "change" },
                ],
                signInAddress:[
                    { required: true, message: "请输入签到地址", trigger: "blur" },
                ],
                signInDistance:[
                    { required: true, message: "请输入签到范围", trigger: "blur" },
                ],
                formTime: [
                    { required: true, validator: this.checkValidator }
                ],
                signInTime: [
                    { required: true, validator: this.checksignInTimeValidator }
                ],
                signOutTime: [
                    { required: true, validator: this.checksignOutTimeValidator }
                ],
                secondSignInTime: [
                    { required: true, validator: this.checksecondSignInTimeValidator }
                ],
                secondSignOutTime: [
                    { required: true, validator: this.checksecondSignOutTimeValidator }
                ]
            },
            qrCode: {
                shareUrl: '',
                size: 100,
                margin:5,
                logoMargin:5,
            },
            // 量表
            scaleData:{},
            scaleShow:false,
            //评论区
            discussType:1, //研讨内容类型：1-文字 2-图片 3-音频 4-附件
            discussWordContent:'',
            wordContent: '',//文字评论
            imgContent: '',//图片评论
            fileContent: '',//附件评论
            discussList:[],
            // 编辑
            role: this.$storage.get("role"),
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            evaVideoIsDisplay:false,
            leadTeacherList: [],
            userList: [],
            groupList: [],
            natureList: [],
            oldCenter: [],
            countyList: [],
            schoolList: [],
            orgList: [],
            rateScaleList:[],
            fileList: [],
            defaultProps: {
                children: 'groupList',
                label: 'title',
            },
            isShowSum:false, //听评课总结
            summaryForm:{
                lessonId:"",
                teachContent:"",//教学内容
                teachMethod:"",//教学方法
                classroomMood:"",//课堂氛围

                teaInterest:"",//教师行为-激发兴趣
                teaAware:"",//教师行为-达标意识
                teaExperience:"",//教师行为-引导体验
                teaFeedback:"",//教师行为-评价反馈
                teaGuide:"",//教师行为-讲授指导

                stuStatus:"",//学生行为-参与状态
                stuScope:"",//学生行为-参与广度
                stuThink:"",//学生行为-有效思维
                stuResult:"",//学生行为-合作效果
                stuAim:"",//学生行为-目标达成

                teaStuRelation:"",//师生关系
                otherContent:"",//其他内容
            },

            disabled: true,
            isHide: false,
            previewData: {},
            previewShow: false,
            //听评课量表统计
            isRateScaleShow:false,
            isSatisfiedShow:false,
            activeTabName:'0',
            activeIndex:null,
            activeNames:'',
            scaleId:'',
            scaleTitle:'',
            evaLessonTitle:'', //当前听评课标题
            userRecordList:[], //当前量表填写记录
            questionList:[],  //当前量表问题统计
            scaleStatsList:[], //量表 统计数据
            pieQuIds:'', //饼图问题ID
            barQuIds:'', //柱状图问题ID
            courseClassifyList: [],
            satisfiedScaleList:[],
            scaleList1:[], // 满意度调查量表
            scaleList2:[], // 其他量表
            isHomeworkShow:false,
            isHomeworkEditShow:false,
            isHomeworkFinishShow:false,
            isShowHomework:false,
            isHomeworkDetailShow:false,
            isCheckHomework:false,//查看或批阅
            isHomeworkReadShow:false,//批阅作业
            homeworkFileList: [],
            homeworkList:[],
            selHomeworkList:[],
            homeworkFormRules:{
                title: [{ required: true, message: "请填写作业标题", trigger: "blur" },],
                content: [{ required: true, message: "请填写作业内容", trigger: "blur" },],
                endTime: [{ required: true, validator: this.checkTimeValidator }],
            },
            homeworkForm:{
                relationId:'',
                title:'',
                content:'',
                endTime:'',
                fileUrls:''
            },
            homeworkFinishFileList: [],
            homeworkFinishForm:{
                homeworkId:'',
                content:'',
                fileUrls:'',
            },
            homeworkFinishFormRules:{
                homeworkId: [{ required: true, message: "请选择作业", trigger: "change" },],
                content: [{ required: true, message: "请填写作业内容", trigger: "blur" },],
            },
            homeworkReadFormRules:{
                assessLevel: [{ required: true, message: "请选择评价等级", trigger: "change" },],
            },
            homeworkUserFinishList:[],
            homeworkInfo:{},
            homeworkReadForm:{
                homeworkTitle:'',
                userName:'',
                finishId:'',
                assessLevel:null,
                comment:'',
            },
        };
    },
    created() {
        this.role = this.$storage.get("role");
        this.getQueryDict()
    },
    mounted() {
        // this.qrCode.shareUrl = serviceWebUrl+'/inviteMember?id=' + this.trainId + '&type=3'
        this.qrCode.shareUrl = serviceWebUrl+'/inviteTrain?taskId=' + this.trainId
        this.queryLessonInfo()
        this.getDisList()
        this.getOrgListTypeOrg()
        this.getRateScaleList();
        // this.handleHomework()
    },
    computed: {},
    methods: {
        handleHomework(){
            homeworkList({relationId:this.trainId}).then(res =>{
                if (res.data.code == 1) {
                    this.homeworkForm.relationId = this.trainId;
                    this.homeworkList = res.data.data;
                    this.isHomeworkShow = true;
                } else {
                    this.$message.error("操作失败");
                }
            })
        },

        checkjoinUsersList(rule, value, callback) {
            if (this.$refs.joinUsersList.checkList.length === 0) {
                callback(new Error('请选择参与人员'))
            } else {
                callback()
            }
        },
        checkCoverValidator(rule, value, callback) {
            // rule规则对象
            // value关联表单值
            // callback() 回传结果
            if (this.lessonInfo.coverUrl !== '') {
                callback()
            } else {
                callback(new Error('请上传封面'))
            }
        },
        checkValidator(rule, value, callback) {
            // rule规则对象
            // value关联表单值
            // callback() 回传结果
            if (this.lessonInfo.beginTime === '' || !this.lessonInfo.beginTime) {
                callback(new Error('请选择开始日期'))
            } else if (this.lessonInfo.endTime === '' || !this.lessonInfo.endTime) {
                callback(new Error('请选择结束日期'))
            } else {
                callback()
            }
        },
        checksignInTimeValidator(rule, value, callback) {
            if (this.lessonInfo.signInBeginTime && !this.lessonInfo.signInEndTime) {
                callback(new Error('请选择结束时间'))
            } else if (this.lessonInfo.signInEndTime && !this.lessonInfo.signInBeginTime) {
                callback(new Error('请选择开始时间'))
            } else if (!this.lessonInfo.signInEndTime && !this.lessonInfo.signInBeginTime) {
                callback(new Error('请选择签到时间'))
            } else {
                callback()
            }
        },
        checksecondSignInTimeValidator(rule, value, callback){
            if (this.lessonInfo.secondSignInBeginTime && !this.lessonInfo.secondSignInEndTime) {
                callback(new Error('请选择结束时间'))
            } else if (this.lessonInfo.secondSignInEndTime && !this.lessonInfo.secondSignInBeginTime) {
                callback(new Error('请选择开始时间'))
            } else if (!this.lessonInfo.secondSignInEndTime && !this.lessonInfo.secondSignInBeginTime) {
                callback(new Error('请选择二次签到时间'))
            } else {
                callback()
            }
        },
        checksignOutTimeValidator(rule, value, callback) {
            if (this.lessonInfo.signOutBeginTime && !this.lessonInfo.signOutEndTime) {
                callback(new Error('请选择结束时间'))
            } else if (this.lessonInfo.signOutEndTime && !this.lessonInfo.signOutBeginTime) {
                callback(new Error('请选择开始时间'))
            } else if (!this.lessonInfo.signInEndTime && !this.lessonInfo.signInBeginTime) {
                callback(new Error('请选择签退时间'))
            } else {
                callback()
            }
        },
        checksecondSignOutTimeValidator(rule, value, callback){
            if (this.lessonInfo.secondSignOutBeginTime && !this.lessonInfo.secondSignOutEndTime) {
                callback(new Error('请选择结束时间'))
            } else if (this.lessonInfo.secondSignOutEndTime && !this.lessonInfo.secondSignOutBeginTime) {
                callback(new Error('请选择开始时间'))
            } else if (!this.lessonInfo.secondSignOutEndTime && !this.lessonInfo.secondSignOutBeginTime) {
                callback(new Error('请选择二次签到时间'))
            } else {
                callback()
            }
        },
        editLesson(){
            this.showMode = this.editMode;
        },
        cancel(){
            this.showMode = this.viewMode;
        },
        queryLessonInfo(){
            trainInfo({ trainId: this.trainId }).then(res => {
                if (res.data.code===1){
                    // this.changeLessonNature(res.data.data.lessonNature)
                    this.lessonInfo = res.data.data;
                    //班主任
                    const textLeadTeacherList = [];
                    this.lessonInfo.leadTeacherList.forEach(e => {
                        textLeadTeacherList.push(e.trueName)
                    })
                    this.lessonInfo.leadTeacherNames = textLeadTeacherList.join('、')
                    //副班主任
                    const textViceLeadTeacherList = [];
                    this.lessonInfo.viceLeadTeacherList.forEach(e => {
                        textViceLeadTeacherList.push(e.trueName)
                    })
                    this.lessonInfo.viceLeadTeacherNames = textViceLeadTeacherList.join('、')
                    //参与人
                    const textList = [];
                    this.lessonInfo.joinUserList.forEach(e => {
                        textList.push(e.trueName)
                    })
                    this.lessonInfo.joinUsersText = textList.join('、')
                    if (this.lessonInfo.type === 2) {
                        this.oldCenter = [this.lessonInfo.lng, this.lessonInfo.lat]
                    }
                    this.lessonInfo.fileList.forEach(e => {
                        this.fileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: {
                                data: e.fileUrl
                            }
                        })
                    })

                    if (!this.lessonInfo.signCount) {
                        this.lessonInfo.signCount = 2;
                    }
                    this.lessonInfo.signInTime = [this.lessonInfo.signInBeginTime, this.lessonInfo.signInEndTime];
                    this.lessonInfo.signOutTime = [this.lessonInfo.signOutBeginTime, this.lessonInfo.signOutEndTime];
                    this.lessonInfo.trainLevel = this.lessonInfo.trainLevel + ''
                    //班主任
                    this.$refs.leadTeacherList.checkList = this.lessonInfo.leadTeacherList;
                    this.$refs.viceLeadTeacherList.checkList = this.lessonInfo.viceLeadTeacherList;

                    //参与人
                    this.$refs.joinUsersList.checkList = this.lessonInfo.joinUserList;
                    if (this.lessonInfo.trainNature && this.lessonInfo.trainNature === 4) {
                        this.$refs.joinUsersList.getQunPeople(this.lessonInfo.groupId)
                    }
                    if (this.lessonInfo.type === 1){
                        this.lessonInfo.lbType = 0
                    }
                    if (this.lessonInfo.type === 3){
                        this.lessonInfo.type = 1
                        this.lessonInfo.lbType = 1
                    }
                    this.scaleList1 = this.lessonInfo.satisfiedScaleList;
                    this.scaleList2 = this.lessonInfo.scaleList;
                    this.lessonInfo.scaleList = this.lessonInfo.scaleIds && this.lessonInfo.scaleIds.split(',')

                    if (this.lessonInfo.type === 2) {
                        this.oldCenter = [this.lessonInfo.lng, this.lessonInfo.lat]
                    }

                    this.isShowMap = true;
                    if (this.lessonInfo.type === 2) {
                        setTimeout(() => {
                            this.$refs.zdyMap.center = this.oldCenter;
                            this.$refs.zdyMap.componentMarker.position = this.oldCenter;
                            this.$refs.zdyMap1.center = this.oldCenter;
                            this.$refs.zdyMap1.componentMarker.position = this.oldCenter;
                        }, 100)
                    }
                    this.showMode = this.viewMode;
                }
            })
        },
        stopLesson(){
            trainStop({ trainId: this.trainId }).then(res => {
                if (res.data.code == 1) {
                    this.queryLessonInfo()
                    this.$message.success("操作成功");
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        viewFile(file){},
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {

            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,){
            const list = [];
            for (let i = 1; i <=page ; i++) {
                list.push(baseUrl+'/' + i+'.png');
            }
            return list;
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'topic_level' }).then(res => {
                this.lessonLevelList = res.data.data;
            })
            queryDict({ code: 'activity_nature' }).then(res => {
                this.natureList = res.data.data;
            })
            queryDict({ code: 'train_classify' }).then(res => {
                this.courseClassifyList = res.data.data;
            })
        },
        changePeriod() {
            this.lessonInfo.gradeKey = '';
            this.lessonInfo.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.lessonInfo.periodKey == j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
        },
        changeGrade() {
            this.lessonInfo.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.lessonInfo.periodKey == e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.lessonInfo.gradeKey == j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
        },
        handleCoverSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.lessonInfo.coverUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeCoverUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        changeTitle(row) {
            this.lessonInfo.title = row.className + '­—' + row.ptit + (row.title ? '­—' + row.title : '')
            this.isDirectory = false;
            this.isCourse = false;
        },
        objectSpanMethod(e) {
            // console.log(e);
            if (e.columnIndex === 0) {
                if (e.row.col != 0) {
                    return {
                        rowspan: e.row.col,
                        colspan: 1,
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    }
                }
            }
        },
        handleXTChange(file) {},
        handleJAChange(file) {},
        handleXAChange(file) {},
        handleKjChange(file) {},
        beforeJAUpload(rawFile) {
            if (!(rawFile.type == 'application/pdf' || rawFile.type == 'application/vnd.ms-powerpoint' || rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || rawFile.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || rawFile.type == 'application/msword')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx,.doc,.docx格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }
            return true
        },
        handleRemove(file, uploadFiles) {
            if (file.response.data) {
                this.delFileList.push(file.response.data)
            }
        },
        checkrateTeacherList(rule, value, callback) {
            if (this.$refs.rateTeacherList.checkList.length === 0) {
                callback(new Error('请选择评课教师'))
            } else {
                callback()
            }
        },
        checklistenTeacherList(rule, value, callback) {
            if (this.$refs.listenTeacherList.checkList.length === 0) {
                callback(new Error('请选择听课教师'))
            } else {
                callback()
            }
        },
        submitForm() {
            this.lessonInfo.beginTime = this.setHms(this.lessonInfo.beginTime);
            this.lessonInfo.endTime = this.setHms(this.lessonInfo.endTime);

            this.lessonInfo.signInBeginTime = this.setHms(this.lessonInfo.signInBeginTime);
            this.lessonInfo.signInEndTime = this.setHms(this.lessonInfo.signInEndTime);
            this.lessonInfo.signOutBeginTime = this.setHms(this.lessonInfo.signOutBeginTime);
            this.lessonInfo.signOutEndTime = this.setHms(this.lessonInfo.signOutEndTime);

            this.lessonInfo.secondSignInBeginTime = this.setHms(this.lessonInfo.secondSignInBeginTime);
            this.lessonInfo.secondSignInEndTime = this.setHms(this.lessonInfo.secondSignInEndTime);
            this.lessonInfo.secondSignOutBeginTime = this.setHms(this.lessonInfo.secondSignOutBeginTime);
            this.lessonInfo.secondSignOutEndTime = this.setHms(this.lessonInfo.secondSignOutEndTime);
            //班主任
            this.lessonInfo.leadTeacherList = []
            this.$refs.leadTeacherList.checkList.forEach(e => {
                this.lessonInfo.leadTeacherList.push(e.userId)
            })
            this.lessonInfo.leadTeacher = this.lessonInfo.leadTeacherList.toString()
            //副班主任
            this.lessonInfo.viceLeadTeacherList = []
            this.$refs.viceLeadTeacherList.checkList.forEach(e => {
                this.lessonInfo.viceLeadTeacherList.push(e.userId)
            })
            this.lessonInfo.viceLeadTeacher = this.lessonInfo.viceLeadTeacherList.toString()
            //参与人
            this.lessonInfo.joinUsersList = [];
            this.$refs.joinUsersList.checkList.forEach(e => {
                this.lessonInfo.joinUsersList.push(e.userId)
            })
            this.lessonInfo.joinUsers = this.lessonInfo.joinUsersList.toString()
            //培训课程
            if (this.lessonInfo.type === 1&&this.lessonInfo.lbType ===0){
                this.lessonInfo.courseIds = this.$refs.selCourseId.courseId;
            }
            if (this.lessonInfo.type === 1 && this.lessonInfo.lbType ===1){
                this.lessonInfo.type = 3;
            }
            var fileList = [];
            this.fileList.forEach((e) => {
                if (e.response.code === 1) {
                    fileList.push(e.response.data);
                }
            })

            this.$refs["form"].validate(valid => {
                if (valid) {
                    var obj = JSON.parse(JSON.stringify(this.lessonInfo));
                    obj.fileUrls = fileList.toString();
                    obj.scaleIds = obj.scaleList.toString();
                    delete obj.joinUsersList
                    trainUpdate(obj).then(res => {
                        if (res.data.code === 1) {
                            this.fileList = []
                            this.delFileList.forEach(e => {
                                trainDeleteFile({ fileUrl: e });
                            })
                            this.queryLessonInfo()
                            this.$message.success("操作成功");
                        } else {
                            this.$message.error("操作失败")
                        }

                    });


                }
            });
        },
        handleGAJaChange(e, type) {
            if (e.response) {
                if (e.response.code == 1) {
                    let arr = []
                    this.lessonInfo.gajaFiles.forEach(j => {
                        var fileUrl = ''
                        if (j.url) {
                            fileUrl = j.url
                        } else {
                            fileUrl = j.response.data
                        }
                        if (fileUrl != e.response.data) {
                            arr.push(new Promise(function (resolve, reject) {
                                delLessonFile({ fileUrl: fileUrl }).then(res => {
                                    resolve(res.data.code)
                                })
                            }))
                        }
                    })
                    Promise.all(arr).then((result) => {
                        this.queryLessonInfo()
                    })

                } else {

                }
            }
        },
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.lessonInfo.coverUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        beforeAvatarUpload(rawFile) {
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },

        handleTkDownload() {
            html2canvas(this.$refs.tkcode.$el, {
                backgroundColor: "#ffffff",
                useCORS: true,
                allowTaint: true,
                scale: 2,
                dpi: 300
            }).then(async canvas => {
                // 生成图片地址
                const imgUrl = canvas.toDataURL('image/png');
                const eleLink = document.createElement('a');
                eleLink.href = imgUrl;
                eleLink.download = this.lessonInfo.title + '-培训邀请码.png';
                // // 下载
                eleLink.click();
            })
        },

        getGeocoder(e) {
            this.lessonInfo.lat = e.center[1];
            this.lessonInfo.lng = e.center[0];
            this.lessonInfo.signInAddress = e.formattedAddress;

        },
        // 预览量表
        previewScale(item) {
            rateScaleInfo({ scaleId: item.scaleId }).then(res => {
                this.scaleData = res.data.data;
                this.scaleShow = true;
            })
        },
        // 评论区
        handleUploadImageSuccess(response, uploadFile){
            if (uploadFile.response.code === 1) {
                this.imgContent = uploadFile.response.data;
                this.discussType = 2
                this.submitDiscuss()
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeImageUpload(rawFile){
            if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        handleUploadFileSuccess(response, uploadFile){
            if (uploadFile.response.code === 1) {
                this.fileContent = uploadFile.response.data;
                this.discussType = 4
                this.submitDiscuss()
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeFileUpload(rawFile){
            return true
        },
        focusInput(){
            this.closeInput = false
        },
        handleUnKnow(){
            this.$message.info("该文件类型暂不支持预览")
        },
        comStr(baseStr,type){
            return type!==''&& type.toUpperCase().includes(baseStr.toUpperCase());
        },
        getDisList() {
            listTrainDiscuss({ trainId: this.trainId }).then(res => {
                this.discussList = res.data.data;
            })
        },
        submitDiscuss(){

            const obj = {
                trainId: this.trainId,
                content: this.wordContent,
                imgContent: this.imgContent,
                fileContent: this.fileContent,
            };
            //文字评论
            if (this.discussType===1){
                this.wordContent = this.discussWordContent
                if (this.wordContent===''){
                    this.$message.info("讨论内容不能为空")
                    return
                }
                obj.content=this.wordContent;
                obj.imgContent = '';
                obj.fileContent = ''
            }
            //图片评论
            if (this.discussType===2){
                if (this.imgContent===''){
                    this.$message.info("研讨内容不能为空")
                    return
                }
                obj.content='';
                obj.imgContent = this.imgContent;
                obj.fileContent = ''
            }
            //附件评论
            if (this.discussType===4){
                if (this.fileContent===''){
                    this.$message.info("研讨内容不能为空")
                    return
                }
                obj.content='';
                obj.imgContent = '';
                obj.fileContent = this.fileContent
            }
            const loading = ElLoading.service({ fullscreen: true })
            submitTrainDiscuss(obj).then(res =>{
                if (res.data.code === 1) {
                    this.$message.success("发表成功");
                    this.wordContent = ''
                    this.discussWordContent = ''
                    this.imgContent = ''
                    this.fileContent = ''
                    this.discussType = 1
                    this.getDisList();
                } else {
                    this.$message.error("操作失败")
                    this.discussType = 1
                }
            })
            loading.close();
        },
        sxKj() {
            // this.$refs.joinUsersList.checkList = [];
        },
        getOrgListTypeOrg() {
            listUserManagerOrg().then(res => {
                this.countyList = res.data.data;
            })
        },
        changeCounty() {
            this.lessonInfo.schoolId = '';
            this.schoolList = [];
            orgListSchoolOrg({ orgId: this.lessonInfo.countyId }).then(res => {
                this.schoolList = res.data.data;
            })
        },
        getRateScaleList() {
            rateScaleList({ scaleType: 2 }).then(res => {
                this.rateScaleList = res.data.data;
            })
            rateScaleList({ scaleType: 6 }).then(res => {
                this.satisfiedScaleList = res.data.data;
            })
        },
        startDateConfirm(e) {
            if (e >= this.lessonInfo.endTime) {
                this.lessonInfo.endTime = '';
            }
        },
        endDateConfirm(e) {
            if (e <= this.lessonInfo.beginTime) {
                this.lessonInfo.beginTime = '';
            }
        },
        disabledDate(current) {
            return current && current < Number(new Date()) - 86400000
        },
        enddisabledDate(current) {
            if (this.lessonInfo.beginTime) {
                return current && current < this.lessonInfo.beginTime
            } else {
                return current && current < Number(new Date()) - 86400000
            }
        },
        showUpload(){
            this.evaVideoIsDisplay = true;
        },
        handleExceed(){},
        handleUpload(option){
            const loading = ElLoading.service({ fullscreen: true })
            var obj = option.file.name
            const index = obj.lastIndexOf(".");
            obj = obj.substring(index, obj.length);
            // 生成的文件名，保留文件后缀名，进行拼接
            let objName = getFileNameUUID() + this.getFileName(option.file.name)
            this.loadingPercentage = 0;
            this.multipartUpload(`/ygjy/user-video/${objName}`, option.file).then(res => {
                signatureUrl(`/ygjy/user-video/${objName}`).then(res => {
                    var lastQuestionMarkIndex = res.lastIndexOf("?")
                    var result = res;
                    if (lastQuestionMarkIndex !== -1) {
                        result = res.substring(0, lastQuestionMarkIndex);
                        this.lessonInfo.address = result;
                        loading.close()
                        this.evaVideoIsDisplay = false;
                    } else {
                        loading.close()
                    }
                })
            })
        },
        lessonTeamUser(userList){
            this.$refs.listenTeacherList.checkList = userList;
            this.gxDisable();
            this.$refs.listenTeacherList.disabledList = [...this.$refs.lectureTeacher.checkList, ...this.$refs.rateTeacherList.checkList]
        },
        gxDisable() {
            this.$refs.lectureTeacher.disabledList = [...this.$refs.rateTeacherList.checkList, ...this.$refs.listenTeacherList.checkList]
            this.$refs.rateTeacherList.disabledList = [...this.$refs.lectureTeacher.checkList, ...this.$refs.listenTeacherList.checkList]
            this.$refs.listenTeacherList.disabledList = [...this.$refs.lectureTeacher.checkList, ...this.$refs.rateTeacherList.checkList]
            this.$refs.guideUsersList.disabledList = [...this.$refs.lectureTeacher.checkList]
            this.leadTeacherList = [];
            this.$refs.rateTeacherList.checkList.forEach(e => {
                this.leadTeacherList.push(e)
            })
            const rateCheckList = []
            this.$refs.rateTeacherList.checkList.forEach(e => {
                rateCheckList.push(e.userId)
            })
            if (rateCheckList.indexOf(this.lessonInfo.leadTeacher) === -1) {
                this.lessonInfo.leadTeacher = ''
            }
            this.$forceUpdate()
        },
        handleStop() {
            evaluationStop({ lessonId: this.lessonId }).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("操作成功");
                    this.queryLessonInfo();
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleComplete(item) {
            if(this.lessonInfo.role===3||this.lessonInfo.role===1||this.lessonInfo.role===0){
                this.disabled = false;
            }
            console.log(this.disabled)
            this.isHide = false;
            if (item.isSub == 1) {
                rateRecordScoreInfo({ lessonId: this.lessonId, scaleId: item.scaleId }).then(res => {
                    if (res.data.data.info.isHide == 1) {
                        this.isHide = true;
                    }
                    this.previewData = res.data.data.info;
                    this.previewData.questionList.forEach(e => {
                        if (e.type == 2) {
                            e.questionAnswer = e.questionAnswer.split(',');
                        } else {
                            // e.questionAnswer = '';
                        }
                    })
                    this.previewShow = true;
                })
            } else {
                rateScaleInfo({ scaleId: item.scaleId }).then(res => {
                    this.previewData = res.data.data;
                    this.previewData.questionList.forEach(e => {
                        if (e.type == 2) {
                            e.questionAnswer = [];
                        } else {
                            e.questionAnswer = '';
                        }

                    })
                    this.previewShow = true;
                })
            }
        },
        submitPreviewForm() {
            var obj = {};
            obj.scaleId = this.$refs.editData.previewData.scaleId;
            obj.lessonId = this.lessonId;
            obj.answerList = [];
            if (this.$refs.editData.isHide) {
                obj.isHide = 1;
            } else {
                obj.isHide = 0;
            }
            var totalScore = 0;
            this.$refs.editData.previewData.questionList.forEach(e => {
                if (e.type == 2) {
                    var txt = e.questionAnswer.toString()
                    obj.answerList.push({
                        questionId: e.questionId,
                        questionAnswer: txt
                    })
                    e.questionAnswer.forEach(m=>{
                        e.itemList.forEach(j=>{
                            if(m == j.itemId){
                                totalScore += Number(j.itemValue)
                            }
                        })
                    })
                } else {
                    if(e.type == 1){
                        e.itemList.forEach(j=>{
                            if(e.questionAnswer == j.itemId){
                                totalScore += Number(j.itemValue)
                            }
                        })
                    }
                    if(e.type == 3){
                        totalScore += Number(e.questionAnswer)
                    }
                    obj.answerList.push({
                        questionId: e.questionId,
                        questionAnswer: e.questionAnswer
                    })
                }

            })
            obj.totalScore = totalScore;
            rateRecordScore(obj).then(res => {
                if (res.data.code == 1) {
                    this.previewShow = false;
                    this.isHide = false;
                    this.$message.success('提交成功')
                    this.queryLessonInfo();
                } else {
                    this.$message.error(res.data.msg)
                }
            })

        },
        closePreview() {
            this.previewShow = false;
        },
        // 听评课量表统计
        handleRateScale(item){
            const sId = item.scaleId;
            this.evaLessonTitle = this.lessonInfo.title;
            this.isRateScaleShow = true;
            this.activeIndex = null
            this.userRecordList = []
            this.questionList = []
            this.pieQuIds = ''
            this.barQuIds = ''
            statsTrainRate({trainId:this.trainId}).then(res => {
                if (res.data.code === 1){
                    this.scaleStatsList = res.data.data;
                    this.scaleStatsList.forEach(e => {
                        if (sId===e.scaleId){
                            this.scaleId = e.scaleId;
                            this.scaleTitle = e.title;
                            this.userRecordList = e.userRecordList;
                            this.questionList = e.questionList;
                            this.pieQuIds = ''
                            this.barQuIds = ''
                            this.questionList.forEach(q  => {
                                this.pieQuIds = this.pieQuIds+q.questionId
                            })
                        }
                    })
                    this.isRateScaleShow = true;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        handleTabsClick(item){
            this.activeTab = item.name;
        },
        changeScale(item){
            this.scaleId = item.scaleId;
            this.scaleTitle = item.title;
            this.userRecordList = item.userRecordList;
            this.questionList = item.questionList;
            this.pieQuIds = ''
            this.barQuIds = ''
            this.questionList.forEach(q  => {
                this.pieQuIds = this.pieQuIds+q.questionId
            })
            console.log("饼图显示："+this.pieQuIds)
        },
        handlePieQuestion(qId){
            if (!this.pieQuIds.includes(qId)){
                this.pieQuIds = this.pieQuIds+qId;
            }
            if (this.barQuIds.includes(qId)){
                this.barQuIds = this.barQuIds.replace(qId,'');
            }
        },
        handleBarQuestion(qId){
            if (!this.barQuIds.includes(qId)){
                this.barQuIds = this.barQuIds +qId;
            }
            if (this.pieQuIds.includes(qId)){
                this.pieQuIds = this.pieQuIds.replace(qId,'');
            }
        },
        handleChange(index){
            this.activeIndex = index
        },
        hideStat({ row, rowIndex }){
            if (row.answerCount===0){
                // return 'hidden-row'
                return '';
            }
            return '';
        },
        handleSatisfiedScale(item){
            this.trainTitle = item.title;
            this.isRateScaleShow = true;
            this.activeIndex = null ;
            this.userRecordList = []
            this.questionList = []
            this.pieQuIds = ''
            this.barQuIds = ''
            statsSatisfiedRate({trainId:this.trainId}).then(res => {
                if (res.data.code == 1){
                    this.scaleStatsList = res.data.data;
                    if (this.scaleStatsList){
                        this.scaleId = this.scaleStatsList[0].scaleId;
                        this.scaleTitle = this.scaleStatsList[0].title;
                        this.userRecordList = this.scaleStatsList[0].userRecordList;
                        this.questionList = this.scaleStatsList[0].questionList;

                        this.questionList.forEach(q  => {
                            this.pieQuIds = this.pieQuIds+q.questionId
                        })
                    }
                    this.isRateScaleShow = true;
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        changeLessonNature(e) {
            this.groupList = [];
            this.lessonInfo.groupId = '';
            if (e == 1) {
                this.sxKj()
            } else if (e == 2) {
                groupListAuthGroup({ groupNature: 2 }).then(res => {
                    this.groupList = res.data.data;
                })
                this.sxKj()
            } else if (e == 3) {
                groupListAuthGroup({ groupNature: 3 }).then(res => {
                    this.groupList = res.data.data;
                })
                this.sxKj()
            } else if (e == 4) {
                this.sxKj()
                groupListAuthGroup({ groupNature: 1 }).then(res => {
                    this.groupList = res.data.data;
                })
            }
        },
        changeQun() {
            this.sxKj()
            // this.$refs.leadUser.getQunPeople(this.lessonInfo.groupId)
        },
        startsignInConfirm(e) {
            if (e >= this.lessonInfo.signInEndTime) {
                this.lessonInfo.signInEndTime = '';
            }
        },
        startSecondsignInConfirm(e) {
            console.log(e);
            if (e >= this.lessonInfo.secondSignInEndTime) {
                this.lessonInfo.secondSignInEndTime = '';
            }
        },
        startsignOutConfirm(e) {
            if (e >= this.lessonInfo.signOutEndTime) {
                this.lessonInfo.signOutEndTime = '';
            }
        },
        startSecondsignOutConfirm(e) {
            if (e >= this.lessonInfo.secondSignOutEndTime) {
                this.lessonInfo.secondSignOutEndTime = '';
            }
        },
        endsignOutConfirm(e) {
            if (e <= this.lessonInfo.signOutBeginTime) {
                this.lessonInfo.signOutBeginTime = '';
            }
        },
        endSecondsignOutConfirm(e) {
            if (e <= this.lessonInfo.secondSignOutBeginTime) {
                this.lessonInfo.secondSignOutBeginTime = '';
            }
        },
        endsignInConfirm(e) {
            if (e <= this.lessonInfo.signInBeginTime) {
                this.lessonInfo.signInBeginTime = '';
            }
        },
        endSecondsignInConfirm(e) {
            if (e <= this.lessonInfo.secondSignInBeginTime) {
                this.lessonInfo.secondSignInBeginTime = '';
            }
        },

        arrangeHomework(){
            this.isHomeworkEditShow = !this.isHomeworkEditShow;
        },
        arrangeHomeworkFinish(){
            this.isHomeworkFinishShow = !this.isHomeworkFinishShow;
        },
        submitHomeworkForm(){
            this.$refs["homeworkForm"].validate(valid => {
                if (!valid){
                    return
                }
                const fileList = [];
                this.homeworkFileList.forEach((e) => {
                    if (e.response.code == 1) {
                        fileList.push(e.response.data);
                    }
                })
                this.homeworkForm.fileUrls =fileList.toString();
                this.homeworkForm.endTime = this.setHms(this.homeworkForm.endTime);
                homeworkCreate(this.homeworkForm).then(res => {
                    if (res.data.code == 1) {
                        this.handleHomework(this.homeworkForm.relationId);
                        this.homeworkForm.title = '';
                        this.homeworkForm.content = '';
                        this.homeworkForm.endTime = '';
                        this.homeworkForm.fileUrls = '';
                        this.homeworkFileList = []
                        this.$message.info("发布成功");
                        this.arrangeHomework();
                    } else {
                        this.$message.error("操作失败");
                    }
                })
            })

        },
        handleDeleteHomework(row){
            homeworkDel({homeworkId:row.homeworkId}).then(res =>{
                if (res.data.code == 1) {
                    this.handleHomework(row.relationId);
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        handleRemoveHomeworkFile(file, uploadFiles) {
            if (file.response.code == 1) {
                homeworkDelAnnex({fileUrl:file.response.data}).then(res =>{
                    if (res.data.code == 1) {
                        this.$message.info("文件已移除")
                    }
                })
            }
        },
        handlePreviewHomeworkFile(uploadFile) {},
        handleChangeHomeworkFile(){},
        beforeUploadHomeworkFile(rawFile) {
            // if (!(rawFile.type == 'image/jpeg' ||
            //   rawFile.type == 'image/png' ||
            //   rawFile.type == 'image/jpg')) {
            //     this.$message.error('图片必须是jpeg、png、jpg格式的')
            //     return false
            // } else if (rawFile.size / 1024 / 1024 > 10) {
            //     this.$message.error('图片大小不能超过10M')
            //     return false
            // }
            return true
        },
        checkTimeValidator(rule, value, callback) {
            // rule规则对象
            // value关联表单值
            // callback() 回传结果
            if (this.homeworkForm.endTime === '' || !this.homeworkForm.endTime) {
                callback(new Error('请选择截止时间'))
            } else {
                callback()
            }
        },
        handleHomeworkFinish(row){
            //查询作业
            homeworkList({relationId:this.trainId}).then(res =>{
                if (res.data.code == 1) {
                    this.selHomeworkList = res.data.data;
                    if (this.selHomeworkList.length !== 0) {
                        this.isHomeworkFinishShow = true;
                    }else {
                        this.$message.error("该培训暂未发布作业");
                    }
                } else {
                    this.$message.error("操作失败");
                }
            })

        },
        homeworkFinishInfo(homeworkId){
            homeworkFinishInfo({homeworkId:homeworkId}).then(res =>{
                if (res.data.code == 1) {
                    if (res.data.data!==null && res.data.data!=='') {
                        this.homeworkFinishForm.content = res.data.data.content;
                        this.homeworkFinishFileList = [];
                        const fileList = res.data.data.fileList;
                        fileList.forEach(e => {
                            this.homeworkFinishFileList
                              .push({name:e.fileName, url: e.fileUrl, response:{code:1,data:e.fileUrl,}});
                        })
                    }else {
                        this.homeworkFinishForm.content = '';
                        this.homeworkFinishFileList = [];
                    }
                }
            })
        },
        submitHomeworkFinishForm(){
            this.$refs["homeworkFinishForm"].validate(valid => {
                if (!valid){
                    return
                }
                const fileList = [];
                this.homeworkFinishFileList.forEach((e) => {
                    if (e.response.code == 1) {
                        fileList.push(e.response.data);
                    }
                })
                this.homeworkFinishForm.fileUrls =fileList.toString();
                homeworkFinish(this.homeworkFinishForm).then(res => {
                    if (res.data.code == 1) {
                        this.homeworkFinishForm.homeworkId = '';
                        this.homeworkFinishForm.content = '';
                        this.homeworkFinishForm.fileUrls = '';
                        this.homeworkFinishFileList = [];
                        this.isHomeworkFinishShow = false;
                        this.$message.success("提交成功")
                    }else {
                        this.$message.error("提交失败")
                    }
                })


            })

        },
        handleFinish(row){
            listHomeworkFinish({homeworkId:row.homeworkId}).then(res =>{
                if (res.data.code == 1) {
                    if (res.data.data!==null && res.data.data!=='') {
                        this.homeworkUserFinishList = res.data.data;
                        this.isShowHomework = true;
                    }else {

                    }
                }
            })
        },
        checkHomework(row,type){
            if (type==1){
                this.isCheckHomework = true;
            }
            this.homeworkInfo = row;
            this.isHomeworkDetailShow = true;
        },
        readHomework(){
            this.homeworkReadForm.finishId = this.homeworkInfo.finishId;
            this.homeworkReadForm.homeworkTitle = this.homeworkInfo.homeworkTitle;
            this.homeworkReadForm.userName = this.homeworkInfo.trueName;
            this.isHomeworkReadShow = true;
        },
        readOverHomeworkSubmit(){
            readOverHomework(this.homeworkReadForm).then(res =>{
                if (res.data.code == 1) {
                    this.$message.success('操作成功');
                    this.homeworkInfo.isAssess = 1;
                    this.homeworkInfo.assessLevel = this.homeworkReadForm.assessLevel;
                    this.homeworkInfo.comment = this.homeworkReadForm.comment;
                    this.isHomeworkReadShow = false
                    listHomeworkFinish({homeworkId:this.homeworkInfo.homeworkId}).then(res =>{
                        if (res.data.code == 1) {
                            if (res.data.data!==null && res.data.data!=='') {
                                this.homeworkUserFinishList = res.data.data;
                            }
                        }
                    })
                }else {
                    this.$message.error('操作失败');
                }
            })
        },

    }
};
</script>
<style scoped>
.el-icon .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 240px;
    height: 152px;
    text-align: center;
}
.course-container{
    width: 100%;
    height: auto;
}
.lesson-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    display: flex;
}
.lesson-edit-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    background-color: #fff;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
.left-container{
    width: calc(100% - 270px);
    height: auto;
    background-color: #fff;
    padding-left: 10px;
    box-sizing: border-box;
    padding-bottom: 10px;
    padding-right: 10px;
}
.right-container{
    width: 260px;
    height: auto;
    margin-left: 10px;
    background-color: #fff;
}
.top-title{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 18px;
    color: #3b62f8;
    font-weight: bold;
}
.info-column-container{
    display: flex;
    width: 100%;
    height: 25px;
    border-bottom: 2px solid #3b62f8;
}
.flex-item:last-child{
    margin-left: auto;
}
.column-title{
    height: 20px;
    line-height: 20px;
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #3b62f8;
    font-size: 16px;
    text-indent: 5px;
    width: 100px;
}
.column-status{
    width: 60px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #a2ef4d;
    font-size: 12px;
    text-align: center;
    color: #e87b17;
}
.column-status-fb{
    width: 60px;
    height: 20px;
    line-height: 20px;
    border-radius: 8px;
    background-color: #e87b17;
    font-size: 12px;
    text-align: center;
    color: #a2ef4d;
}
.column-btn{
    //padding-right: 10px;
    display: flex;
}
.btn{
    width: auto;
    height: 20px;
    border: 1px solid #3b62f8;
    color: #3b62f8;
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 10px;
    padding-left: 5px;
    padding-right: 5px;
}
.base-info-container{
    //display: flex;
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    padding-top: 10px;
}

.info-lesson-title{
    width: 100%;
    height: 45px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    box-sizing: border-box;

}
.base-info-cover{
    width: 240px;
    height: 160px;
    box-sizing: border-box;
    img{
        width: 100%;
        height: 100%;
    }
}

.part-container{
    width: 100%;
    height: auto;
    display: flex;
}
.map-container{
    width: 96%;
    height: auto;
    margin: auto;
    padding-top: 10px;
    padding-bottom: 10px;
}
.part1-l{
    width: calc(100% - 240px);
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}
.part1-r{
    width: 240px;
    height: 100%;
}
.part2-l{
    width: 50%;
    height: 100%;
}
.part2-r{
    width: 50%;
    height: 100%;
    display: flex;
}
.code-item{
    width: 120px;
    height: 150px;
    margin: auto;
    padding-top: 30px;
}
.code-title{
    width: 100%;
    height: 20px;
    text-align: center;
    font-size: 14px;
    font-weight: bold;
}
.code-img{
    cursor: pointer;
}
.info-item{
    width: 100%;
    height: 25px;
    line-height: 25px;
    display: flex;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    div{
        width: 50%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
.info-item-auto{
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 14px;
}
.title-label{
    width: 70px;
}
.content-label{
    width: calc(100% - 70px);
}
.text-content {
    overflow: hidden;
    transition: max-height 0.3s ease-out;
    /* 其他样式 */
}
.eva-btn{
    //padding-left: 10px;
    //padding-right: 10px;
    width: 68px!important;
    background-color: #3b62f8;
    color: #fff;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    font-size: 13px;
}
.file-list{
    width: 100%;
    height: auto;
}
.file-item{
    display: flex;
    height: 30px;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    box-sizing: border-box;
}
.file-item:hover{
    color: #3b62f8!important;
    font-weight: bold;
}
.file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
}
.file-view{
    width: 32px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg{
        cursor: pointer;
    }
}
.file-download{
    width: 30px;
    height: 100%;
}
.file-icon{
    width: 22px;
    height: 22px;
    cursor: pointer;
}
/*讨论区*/
.discuss-title-box{
    height: 20px;
    line-height: 20px;
    background-color: rgba(255,255,255,.9);
    color: #ffbf6b;
    font-weight: bold;
    border-left: 4px solid #3b62f8;
    font-size: 16px;
    text-indent: 5px;
    margin-left: 10px;
    margin-top: 10px;
}

.discuss-uploader{
    width: 26px;
    height: 26px;
}

.discuss-sub-box{
    width: 100%;
    background-color: rgba(255,255,255,.9);
    //border-radius: 8px;
    padding: 10px 10px 0 8px;
    box-sizing: border-box;
    height: 100px;
    //border-bottom: 1px solid #3b62f8;
    .discuss-info{
        display: inline-block;
        width: 250px;
        >>>.el-textarea__inner::placeholder{
            font-size: 12px;
        }
        >>>.el-textarea__inner{
            font-size: 12px;
        }
    }

    .discuss-btn-box{
        display: flex;
        padding: 0 6px;
        margin-top: 10px;
        .el-button--primary{
            width: 56px;
            height: 26px;
            font-size: 12px;
            line-height: 30px!important;
            text-align: center;
            &:hover{
                background-color: #3b62f8;
            }
        }
        .limit{
            width: 26px;
            height: 26px;
            background-color: #3b62f8;
            font-size: 12px;
            color: #999aaa;
            border-radius: 13px;
            margin-right: 10px;
            .icon-upload-img{
                width: 20px;
                height: 20px;
                margin: 3px 0 0 3px;
            }
        }
    }
}

.discuss-show-box{
    width: 260px!important;
    margin: auto;
    height: calc(100vh - 280px)!important;
    padding: 10px 0 0 0;
    background-color: rgba(255,255,255,.9);
}
/deep/ .el-scrollbar__thumb {
    //background-color: #ec623e;
}
/deep/.el-scrollbar__wrap {
    overflow-x: hidden;
}
.discuss-one{
    display: flex;
    padding-bottom: 10px;
    padding-left: 5px;
    background-color: rgba(255,255,255,.9);
    .discuss-user-avatar{
        width: 40px;
        img{
            width: 30px!important;
            height: 30px;
            border-radius: 15px!important;
        }
    }
    .discuss-user-content{
        width: 220px;
        font-size: 14px;
        .user-info{
            display: flex;
            height: 25px;
            padding-right: 10px;
            .flex-item:last-child{
                margin-left: auto;
            }
            .user-true-name{
                font-size: 12px;
                //font-weight: bold;
                //width: 40px;
                height: 25px;
                line-height: 25px;
                text-align: left;
                margin-right: 10px;
                align-content: flex-start;
            }
            .user-role{
                font-size: 10px;
                div{
                    text-align: center;
                }
            }
            .content-time{
                line-height: 25px;
                font-size: 12px;
                align-content: flex-end;
            }
        }
        .content-info{
            padding: 2px 10px 0 0;
            font-size: 11px;
            color: #525B68;
            line-height: 16px;
            word-wrap:break-word;
            word-break:break-all;

        }
        .img-info{
            padding: 2px 10px 0 0;
            display: flex;
            width: 180px;
            flex-wrap: wrap;
            .el-image{
                width: 120px;
                height: auto;
                margin: 0 5px 5px 0;
            }
        }
        .audio-info{
            padding: 2px 10px 0 0;
            audio{
                width: 210px;
                height: 40px;
            }
        }
        .file-info{
            padding: 2px 10px 0 0;
            .file-box{
                width: 210px;
                height: 44px;
                background-color: #f1f3f4;
                border-radius: 5px;
                display: flex;
                .file-icon{
                    width: 40px;
                    height: 40px;
                    img{
                        width: 24px;
                        height: 30px;
                        margin-top: 6px;
                        margin-left: 6px;
                    }
                    .icon-image{
                        width: 24px;
                        height: 30px;
                        margin-top: 6px;
                        margin-left: 6px;
                    }
                }
                .file-detail{
                    width: 160px;
                    height: 40px;
                    padding: 2px 0 2px 0;
                    div{
                        width: 160px;
                        height: 20px;
                    }
                    .name-box{
                        line-height: 24px;
                        font-size: 10px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        cursor: pointer;
                        &:hover{
                            color: #3b62f8;
                        }
                    }
                    .size-box{
                        display: flex;
                        font-size: 10px;
                        line-height: 20px;
                        .file-view{
                            width: 15px;
                            height: 15px;
                            //background-color: #3b62f8;
                            border-radius: 5px;
                            margin-top: 5px;
                            img{
                                width: 13px;
                                height: 13px;
                                margin: 1px 0 0 0;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }

    }

}

.discuss-user-avatar-img{
    width: 30px!important;
    height: 30px;
    border-radius: 15px!important;
}

.role1{
    padding: 1px 4px 1px 4px;
    background-color: #3b62f8;
    margin-top: 4px;
    border-radius: 4px;
    color: #FFFFFF;
    text-align: center;
}
.role2{
    padding: 1px 4px 1px 4px;
    background-color: #f1f1f1;
    margin-top: 4px;
    border-radius: 4px;
    color: #666666;
    text-align: center;
}
.role3{
    padding: 1px 4px 1px 4px;
    background-color: #f1a792;
    margin-top: 4px;
    border-radius: 4px;
    color: #3b62f8;
}
.eva-btn{
    height: 26px!important;
    width: 60px!important;
    font-size: 12px;
    >>>.el-button--primary{
        font-size: 12px;
        text-align: center;
    }
}

/*编辑*/
.scale-item{
    display: flex;
    cursor: pointer;
}

.chart-tab{
    display: flex;
    text-align: center;
    margin: 5px 0;
    color: #333;
    //float: right;
}
.chart-tab ul{
    background: #ebebeb;
    padding: 0 2px;
    list-style: none;
    border: none;
    margin: 0;
    display: block;
}

.chart-tab ul li{
    float: left;
    height: 28px;
    line-height: 26px;
    text-align: center;
    background: #fff;
    border-radius: 2px;
    margin: 2px 1px;
    cursor: pointer;
    padding: 0 4px
}

.fr{
    float: right;
}
.liSel{
    color: #3b62f8;
}



.avatar-uploader .avatar {
    width: 240px;
    height: 152px;
    display: block;
    object-fit: cover;
}

.avatar-uploader /deep/ .el-upload {
    width: 240px;
    height: 152px;
    //border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

</style>

